import config from "appConfig";
import { Slide } from "packages/lesson/dist/@types";
import theory from "../../theory";

const principle: Slide = {
  description:
    "With rendering flexibility, a single object-based mix can be accurately recreated in any target configuration. Choose channel configuration and use headphones to listen to the provided mono samples representing the R, Rs, and Tfr channels. For a specific channel, try to notice changes in the audio signal depending on the selected configuration (2.0 / 5.1 / 5.1.4). Binaural recording containing the complete mix played back over loudspeakers (for a selected configuration) is provided as an additional reference.",
  theory: theory,
  layout: {
    type: "custom032300",
    options: {
      data: {
        "20": {
          R: `${config.ASSETS_URL}/03/23/principle/principle-1-20-r.wav`,
          binaural: `${config.ASSETS_URL}/03/23/principle/principle-1-20-binaural.wav`,
        },
        "51": {
          R: `${config.ASSETS_URL}/03/23/principle/principle-1-51-r.wav`,
          Rs: `${config.ASSETS_URL}/03/23/principle/principle-1-51-rs.wav`,
          binaural: `${config.ASSETS_URL}/03/23/principle/principle-1-51-binaural.wav`,
        },
        "514": {
          R: `${config.ASSETS_URL}/03/23/principle/principle-1-514-r.wav`,
          Rs: `${config.ASSETS_URL}/03/23/principle/principle-1-514-rs.wav`,
          Tfr: `${config.ASSETS_URL}/03/23/principle/principle-1-514-tfr.wav`,
          binaural: `${config.ASSETS_URL}/03/23/principle/principle-1-514-binaural.wav`,
        },
      },
    },
  },
};

export default principle;
